"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.omit")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _Image = _interopRequireDefault(require("../../Image")),
    _NavigationLink = _interopRequireDefault(require("./NavigationLink")),
    _navMenu = require("../styles/navMenu"),
    _Button = _interopRequireDefault(require("../../Button")),
    _Text = _interopRequireDefault(require("../../Text")),
    _Drawer = _interopRequireDefault(require("../../Drawer"));

require("../styles/_nav-menu.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var NAV_OPEN_PREF = "navMenuOpen",
    NavigationMenu = function (a) {
  function b() {
    var a, d;
    (0, _classCallCheck2["default"])(this, b);

    for (var e = arguments.length, f = Array(e), g = 0; g < e; g++) {
      f[g] = arguments[g];
    }

    return (0, _possibleConstructorReturn2["default"])(d, (a = d = c.call.apply(c, [this].concat(f)), d.onToggleExpanded = function (a) {
      localStorage.setItem(NAV_OPEN_PREF, a ? "true" : "");
    }, d.renderNavLink = function (a) {
      var b = a.label,
          c = a.icon,
          e = a.url,
          f = a.selected,
          g = a.onClick,
          h = a.className,
          i = d.props,
          j = i.history,
          k = i.primaryLinksColour,
          l = i.primaryLinksHoverColour,
          m = i.primaryLinksSelectedColour;
      return _react["default"].createElement(_NavigationLink["default"], {
        key: c,
        onClick: g || function () {
          return j.push(e);
        },
        label: b,
        selected: f,
        icon: c,
        className: h,
        linkColour: k,
        linkHoverColor: l,
        linkSelectedColor: m
      });
    }, d.goToHome = function () {
      var a = d.props.history;
      a.push("/");
    }, a));
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.topRoutes,
          c = a.bottomRoutes,
          d = a.isExpandable,
          e = a.logoUrl,
          f = a.primaryColour,
          g = a.title,
          h = a.primaryButtonProps,
          i = a.primaryLinksColour;
      return _react["default"].createElement(_Drawer["default"], {
        isExpandable: d,
        menuColor: f,
        startOpen: !!!localStorage.getItem(NAV_OPEN_PREF),
        onToggleExpanded: this.onToggleExpanded,
        align: "left",
        minimisedWidth: 80,
        showExpandOnHover: !0,
        renderChildrenMinimised: !0,
        width: 240
      }, _react["default"].createElement("div", {
        className: "nav__menu-container"
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])("nav__menu__logo", _navMenu.LOGO_CONTAINER)
      }, _react["default"].createElement("button", {
        type: "button",
        onClick: this.goToHome,
        className: _navMenu.LOGO,
        style: {
          color: i
        }
      }, e ? _react["default"].createElement(_Image["default"], {
        width: "35px",
        height: "35px",
        imageUrl: e,
        backgroundSize: "cover"
      }) : _react["default"].createElement(_Icon["default"], {
        name: "shootstacolour",
        size: 35
      }), _react["default"].createElement(_Text["default"], {
        heading4: !0,
        noMargin: !0
      }, g))), h ? _react["default"].createElement("div", {
        className: "nav__menu__primary-action",
        style: {
          color: i
        }
      }, _react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, (0, _lodash["default"])(h, "children"), {
        type: "TERTIARY",
        prefix: "addfat",
        prefixSize: 15
      })), _react["default"].createElement(_Text["default"], {
        button: !0,
        noMargin: !0
      }, h.children)) : null, _react["default"].createElement("div", {
        className: (0, _classnames["default"])("nav__menu__top-links", _navMenu.TOP_MENU_LINKS)
      }, b.map(this.renderNavLink)), c ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])("nav__menu__bottom-links", _navMenu.BOTTOM_MENU_LINKS)
      }, c.map(this.renderNavLink)) : null));
    }
  }]), b;
}(_react.Component);

exports["default"] = NavigationMenu;